import { RatingScale, RatingScaleScoreDisplay } from '@core/candidate-evaluation-settings-types';

export const THUMBS_4_SCORES = [1, 3, 4, 5];
export const THUMBS_5_SCORES = [1, 2, 3, 4, 5];

export const getRatingScoreLabel = (percent: number, scale: RatingScale): string =>
  scale.scoreDisplay === RatingScaleScoreDisplay.Percentage
    ? `${Math.round(percent)}%`
    : (1 + (percent / 100) * (scale.range - 1)).toFixed(1);
